import { endOfMonth, format, parseISO, startOfDay, startOfMonth } from 'date-fns';

export function dateYmdInMonth(dateYmd: string, month: Date): boolean {
  const d = parseISO(dateYmd);
  return (
    d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth()
  );
}

/** First selectable day in the month (today or later). Falls back to today if the whole month is past. */
export function firstSelectableDayInMonth(
  month: Date,
  today = startOfDay(new Date()),
): string {
  const cursor = startOfMonth(month) < today ? today : startOfMonth(month);
  return format(cursor > endOfMonth(month) ? today : cursor, 'yyyy-MM-dd');
}
